<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div v-if="isCreateNota" class="card-title pt-1 mb-0">
                    <i class="fas fa-file-invoice"></i> Create Nota Supplier
                </div>
                <div v-else class="card-title pt-1 mb-0">
                    <i class="fas fa-file-invoice-dollar"></i> Pembayaran Supplier
                </div>
                <div v-if="!isCreateNota" class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div v-if="isCreateNota" class="alert alert-info mb-0" role="alert">
                    <i class="fas fa-info-circle"></i> Tombol create akan muncul setelah pilih supplier dan centang 1 item atau lebih.
                </div>
                <div class="mb-3">
                    <search-bar :isCreateNota="isCreateNota" :isAllowCreate="isAllowCreate()" @search-set="searchSet" @search-reset="searchReset" @supplier-selected="setSupplier" @create="createNota"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/pembelian-tembakaus"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                        @vuetable:checkbox-toggled="selectPembelians"
                        @vuetable:checkbox-toggled-all="selectPembelians"
                    >
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.pembayaran_supplier" class="badge badge-pill badge-success">Terbayar</span>
                            <span v-else class="badge badge-pill badge-warning">Pending</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="!isCreateNota && (($can('create pembayaran supplier') && (props.rowData.pembayaran_supplier ? isBeforeDay(props.rowData.pembayaran_supplier.created_at) : true)) || isSuperAdmin)" type="button" title="Pembayaran" @click="pembayaran(props.rowData)" class="btn btn-link px-1"><i class="fas fa-hand-holding-usd"></i></button>
                            <button v-if="props.rowData.pembayaran_supplier && !isCreateNota && isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData.pembayaran_supplier)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="viewModal" size="md" :hide-header="true" :hide-footer="true">
            <viewer :isPembayaran="isPembayaran" :value="currentPembelian" @saved="saved" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="showCreateNota" size="lg" :hide-header="true" :hide-footer="true" no-close-on-backdrop no-close-on-esc>
            <create-nota-form :value="getNotaSupplier()" @saved="showCreateNota = false; refresh()" @cancel="showCreateNota = false"></create-nota-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import CreateNotaForm from '../nota-suppliers/Form';

export default {
    name: "pembayaran-supplier",

    props: {
        isCreateNota: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        SearchBar,
        Viewer,
        CreateNotaForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentPembelian: null,
            searchText: '',
            searchDate: null,
            searchStatus: '',
            searchGudangId: '',
            searchGradeId: '',
            searchSupplierId: '',
            viewModal: false,
            showScanQrCode: false,
            isPembayaran: false,
            isSupplierPicked: false,
            prevSupplierId: null,
            showCreateNota: false,
            notaSupplier: null,
            searchSupplier: null,
            selectedPembelians: [],
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            let fields = [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'created_at',
                    title: 'Tanggal',
                    sortField: 'created_at',
                    callback: 'formatDate',
                },
                {
                    name: 'grader.name',
                    title: 'Grader',
                    sortField: 'grader_name',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'supplier.name',
                    title: 'Supplier',
                    sortField: 'supplier_name',
                },
                {
                    name: 'code',
                    title: 'Kode',
                    sortField: 'code',
                },
                {
                    name: 'grade.name',
                    title: 'Grade',
                    sortField: 'grade_name',
                },
                {
                    name: 'bobot',
                    title: 'Berat (kg)',
                    sortField: 'bobot',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ];

            if (this.isCreateNota) {
                fields.splice(1, 0, {
                    name: '__checkbox',
                    titleClass: 'text-center',
                    dataClass: 'text-center'
                });
            } else if (!this.isCreateNota) {
                fields.splice(8, 0, {
                    name: '__slot:status',
                    title: 'Status',
                    sortField: 'pembayaran_supplier_created_at',
                });
                fields.splice(9, 0, {
                    name: 'pembayaran_supplier.created_at',
                    title: 'Pada',
                    sortField: 'pembayaran_supplier_created_at',
                    callback: 'formatDate',
                });
                fields.splice(10, 0, {
                    name: 'pembayaran_supplier.metode',
                    title: 'Metode',
                    callback: 'formatValue',
                });
            }

            return fields;
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_id: this.searchGudangId,
                grade_id: this.searchGradeId,
                supplier_id: this.searchSupplierId,
                is_create_nota: this.isCreateNota,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangId = search.searchGudangId;
            this.searchGradeId = search.searchGradeId;
            this.searchSupplierId = search.searchSupplierId;
            this.isSupplierPicked = this.searchSupplierId ? true : false;
            if (!this.prevSupplierId || this.searchSupplierId != this.prevSupplierId) {
                this.$refs.vuetable.selectedTo = [];
                this.selectedPembelians = [];
            }
            this.prevSupplierId = search.searchSupplierId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = null;
            this.searchStatus = '';
            this.searchGudangId = '';
            this.searchGradeId = '';
            this.searchSupplierId = '';
            this.isSupplierPicked = false;
            this.$refs.vuetable.selectedTo = [];
            this.selectedPembelians = [];
            this.refresh();
        },

        pembayaran(rowData) {
            this.isPembayaran = true;
            this.currentPembelian = Object.assign({}, rowData);
            this.viewModal = true;
        },

        view(rowData) {
            this.isPembayaran = false;
            this.currentPembelian = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.viewModal = false;
            this.currentPembelian = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/pembayaran-suppliers/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        isAllowCreate() {
            if (!this.$refs.vuetable) {
                return false;
            }
            return this.$refs.vuetable.selectedTo.length && this.isSupplierPicked ? true : false;
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/pembayaran-suppliers/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },

        selectPembelians() {
            let items = this.$refs.vuetable.tableData;
            let itemIds = items.map((item) => { return item.id });
            this.selectedPembelians = this.selectedPembelians.filter(selected => {
                return !itemIds.includes(selected.id);
            });

            let selectedItemIds = this.$refs.vuetable.selectedTo;
            let selectedItems = items.filter(item => {
                return selectedItemIds.includes(item.id);
            });

            this.selectedPembelians = this.selectedPembelians.concat(selectedItems);
        },

        getNotaSupplier() {
            let pembelians = this.selectedPembelians;
            return {
                supplier: Object.assign({}, this.searchSupplier),
                pembelians: pembelians,
                sub_total: 0,
                bonus: 0,
                pengurang: 0.5,
                pajak: 0.5,
                pajak_status: false,
                admin: 10000,
                admin_status: false,
                potongan: null,
                potongan_notes: null,
                potongan_status: false,
                metode_pembayaran: null,
                total: 0,
            };
        },

        setSupplier(supplier) {
            this.searchSupplier = Object.assign({}, supplier);
        },

        createNota() {
            this.showCreateNota = true;
        },
    },
}
</script>
